<template>
<b-modal id="card-view-modal" title="License Viewer">
    <div class="modal-body text-center"> 
        <div class="row justify-content-center mt-4">
            <div v-if="contractDetails" class="col-10 col-sm-8">
                {{ contractDetails.license }}
            </div>
        </div>        
    </div>
    <div slot="modal-footer" class="text-center">
        <button type="button" class="btn btn-secondary" @click="hideModal">
            {{ 'CLOSE' | translate }}
        </button>
    </div>
</b-modal>
</template>
 
<script>
import { mapGetters } from "vuex";
import Card from "./Card";
import { CHARACTERS, ELEMENTS } from "../util/constants/cards";

export default {
    name: "modal-card",
    components: { Card },
    data () {
        return {
            action: 'levelup',
            toAddress: null,
            levels: 0
        }
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
            card: 'getCard',
            contractDetails: 'getContractDetails',
            pendingTransaction: 'getPendingTransaction'
        })  
    },
    methods: {
        hideModal () {
            this.$root.$emit('bv::hide::modal','card-view-modal');
        },

        levelUpCard () {
            
            const id = this.card.id;
            const levels = this.levels;

            if (levels * 5 > this.user.tokens) {

                this.$notify({
                    group: 'app',
                    title: 'Warning!',
                    text: 'You do not have enough tokens to level up this much!'                        
                });

                return;

            }

             if (levels == 0) {

                this.$notify({
                    group: 'app',
                    title: 'Warning!',
                    text: 'You cannot levelup by 0!'                        
                });

                return;

            }

             // Close modal
            this.hideModal();

            // Update pending status
            this.$store.commit('updatePendingTransaction', { status: true });   

            this.$store.dispatch('levelupCard', { id, levels }).then((response) => {

                this.$store.commit('updatePendingTransaction', { status: false });    

                if (response.message == 'error') {

                    this.$notify({
                        group: 'app',
                        title: 'Error!',
                        text: 'There was a problem with your transaction!'                        
                    });
                    
                } else {

                    this.$notify({
                        group: 'app',
                        title: 'Success!',
                        text: 'You have leveled-up by ' + levels + '!'                        
                    });

                }

            });
        },

        transferCard () {

            const id = this.card.id;
            const to = this.toAddress;

            if (this.user.address == to) {

                this.$notify({
                    group: 'app',
                    title: 'Warning!',
                    text: 'You cannot send the card to yourself!'                        
                });

                return;
            }

            // Close modal
            this.hideModal();

            // Update pending status
            this.$store.commit('updatePendingTransaction', { status: true });   

            this.$store.dispatch('transferCard', { id, to }).then((response) => {

                this.$store.commit('updatePendingTransaction', { status: false });    

                if (response.message == 'error') {

                    this.$notify({
                        group: 'app',
                        title: 'Error!',
                        text: 'There was a problem with your transaction!'                        
                    });
                    
                } else {

                    this.$notify({
                        group: 'app',
                        title: 'Success!',
                        text: 'You have transfered a card to ' + this.toAddress + '!'                        
                    });

                }

            });

        },

        submitTransaction () { 

            if (this.action == 'levelup') {
                
                this.levelUpCard();

            } else if (this.action == 'transfer') {

                this.transferCard();
            
            }
        }
    }
};
</script>

<style scoped lang="less">
@import "../assets/less/modal.less";
@import "../assets/less/app.less";

.form-label {
    display: inline-block;
    margin-top: 6px;
}
</style>




// WEBPACK FOOTER //
// src/components/ModalCard.vue